const NODES = [
  ['CSR / Sales', 'intake · quote · sales order'],
  ['Client Portal', 'uploads · approvals · requests'],
  ['Prepress', 'artwork · proofs · blueprint'],
  ['Logistics', 'materials · vendors · receiving'],
  ['Production', 'jobs · scheduling · run logs'],
  ['Quality / SQF', 'checks · holds · records'],
  ['Accounting', 'invoice · payment · AP/AR'],
  ['AI Layer', 'agents · summaries · routing'],
];

const NOTES = [
  ['Firebase', 'Stores clients, tasks, statuses, events, indexes, audit logs, AI summaries, and structured records.'],
  ['Google Workspace', 'Hosts Gmail communication, calendar events, Drive files, shared folders, generated PDFs, and docs.'],
  ['AI Orchestration', 'Reads scoped data, classifies intake, summarizes records, recommends actions, supports department agents.'],
];

export default function Architecture() {
  return (
    <>
      <div className="page-head">
        <div>
          <div className="page-title">System Architecture</div>
          <div className="page-sub">How Firebase, Workspace, CRM, AI agents, engines, and department apps connect.</div>
        </div>
      </div>

      <div className="card">
        <div className="card-header"><div><h3>Integrated App Architecture</h3><p>CRM profile, department apps, engines, AI, Workspace, and Firebase sync into one operating loop.</p></div></div>
        <div className="card-body">
          <div className="architecture-map">
            <div className="node core"><div><strong>MFX OS</strong><span>Source of truth · CRM · dashboards · governance</span></div></div>
            {NODES.map(([t, s]) => (
              <div className="node" key={t}><strong>{t}</strong><span>{s}</span></div>
            ))}
          </div>
          <div className="grid cols-3" style={{ marginTop: 16 }}>
            {NOTES.map(([t, s]) => (
              <div className="note-box" key={t}><strong>{t}</strong><br />{s}</div>
            ))}
          </div>
        </div>
      </div>
    </>
  );
}
